module.exports = __webpack_public_path__ + "img/white-arrow-left.28859059.svg";